import React, { useContext, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { ServiceDataForm, ServiceFilters } from '../../../../app/models/Service';
import { WarehouseOrderExtraService, WarehouseOrderExtraServiceFilters } from '../../../../app/models/WareHouseOrderExtraService';
import { AppContext } from '../../../../contexts/AppContext';
import { ServiceResponse } from '../../../../app/services/shared/interfaces';
import useReactConfirmAlert from '../../../../hooks/useReactConfirmAlert';
import DefaultCard from '../../../../components/default/DefaultCard';
import DefaultToolBar from '../../../../components/default/DefaultToolBar';
import ButtonCreate from '../../../../components/buttons/ButtonCreate';
import DefaultModal from '../../../../components/default/DefaultModal';
import WarehouseOrderExtraServiceEdit from '../WarehouseOrderExtraServiceEdit';
import WarehouseExtraServiceCreate from '../WarehouseOrderExtraServiceCreate';
import WarehouseQuoteExtraServiceDataTable from '../../../Quotes/subpages/WareHouseQuote/components/tables/WarehouseQuoteExtraServiceDataTable';
import WarehouseOrderExtraServiceShow from '../WarehouseOrderExtraServiceShow';
import useWarehouseOrderExtraService from '../../../../app/services/hooks/useWareHouseOrderExtraServicesService';

interface Props {
    warehouseOrderId: number;
    // expeditions: WarehouseExpeditionDataForm;
    disableUpdate?: boolean;
    refresh?: number;
    isFormShow?: boolean;

}
const WarehouseOrderExtraServiceContainer = ({
    warehouseOrderId,
    disableUpdate = false,
    isFormShow = false,

    refresh
}: Props) => {
    const {
        getAllWarehouseOrderExtraServicesByOrder,
        deleteWarehouseOrderExtraService,
        storeWarehouseOrderExtraService,
        fetchingGetWarehouseOrderExtraServices
    } = useWarehouseOrderExtraService();
    const [services, setServices] = useState<ServiceDataForm[]>([]);
    const [serviceFilter, setServiceFilter] = useState<ServiceFilters>({
        page: 1,
        per_page: 10,
        sort: 'id',
        order: 'asc'
    });
    const [warehouseQuoteExtraServices, setWarehouseOrderExtraServices] = useState<WarehouseOrderExtraService[]>([]);
    const [totalRows, setTotalRows] = useState<number>(0);
    const [filter, setFilter] = useState<WarehouseOrderExtraServiceFilters>({ page: 1, per_page: 10, sort: 'id', order: 'desc' });
    const [showingEdit, setShowingEdit] = useState(false);
    const [showingShow, setShowingShow] = useState(false);
    const [extraServiceIdEdit, setExtraServiceIdEdit] = useState<number>(-1);
    const [extraServiceIdShow, setExtraServiceIdShow] = useState<number>(-1);
    const [showingCreate, setShowingCreate] = useState(false);
    // const [extraServiceIdShow, setRateIdShow] = useState<number>(-1);
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);

    const showEdit = (id: number) => {
        setShowingEdit(true);
        setExtraServiceIdEdit(id);
    };
    const showShow = (id: number) => {
        setShowingShow(true);
        setExtraServiceIdShow(id);
    };

    const hideEdit = () => {
        setShowingEdit(false);
        setExtraServiceIdEdit(-1);
    };
    const hideShow = () => {
        setShowingShow(false);
        setExtraServiceIdShow(-1);
    };

    const reloadTable = () => {
        getAllWarehouseOrderExtraServicesByOrder(warehouseOrderId,filter, {
            onSuccess: (response: ServiceResponse) => {
                setWarehouseOrderExtraServices(response.data.extra_service);
                setTotalRows(response.data.total_rows || 0);
            }
        });
    };

    // const destroy = (id: number) => {
    //     useSweetAlert().requestConfirmation({
    //         title: '¿Está seguro?',
    //         text: `Está a punto de eliminar el servicio adicional #${id}`,
    //         confirmButtonText: 'Sí, eliminar',
    //         cancelButtonText: 'Cancelar',
    //         onConfirm: () => {
    //             useSweetAlert().spinnerAlert('Eliminando...', 400);
    //             deleteWarehouseExtraService(id, {
    //                 onSuccess: () => {
    //                     toast.success('Eliminado con éxito');
    //                     reloadTable();
    //                 },
    //                 onError: (res) => toast.error(res.message)
    //             });
    //         }
    //     });
    // };

        const destroy = (id: number) => {
        const message = `Está a punto de eliminar el servicio adicional #${id}`;

        useReactConfirmAlert().requestConfirmation({
            title: '¿Estás seguro?',
            message: message,
            buttons: {
                confirmButton: {
                    label: 'Sí, eliminar',
                    onClick: () => {
                        if (showLoading)
                            showLoading('loading', 'Eliminando almacenamiento...');
                        
                        deleteWarehouseOrderExtraService(id, {
                            onSuccess: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().successAlert({
                                    title: 'Éxito',
                                    message: response.message
                                });

                                reloadTable();
                            },
                            onError: (response: ServiceResponse) => {
                                if (hideLoading) hideLoading();

                                useReactConfirmAlert().errorAlert({
                                    title: 'Error',
                                    message: response.message
                                });
                            }
                        });
                    }
                },
                cancelButton: {
                    label: 'Cancelar',
                    onClick: () => {
                        setTimeout(() => {
                            useReactConfirmAlert().infoAlert({
                                title: 'Cancelado',
                                message: 'El almacenamiento no se ha eliminado.'
                            });
                        }, 0);
                    }
                }
            }
        });
    };

    useEffect(() => {
        if (warehouseOrderId) reloadTable();
    }, [warehouseOrderId, filter, refresh]);

    return (
        <>
            <DefaultCard>
                <div className="h3 mt-0 mb-4 card-title">Servicos Adicionales</div> 
                <div className="row">
                    <div className="col-12">
                        {!disableUpdate && (
                            <DefaultToolBar left={<ButtonCreate callbackCreate={() => setShowingCreate(true)} />} />
                        )}
                    </div>
                    <div className="col-12">
                    <WarehouseQuoteExtraServiceDataTable
                        warehouseQuoteExtraServices={warehouseQuoteExtraServices}
                        totalRows={totalRows}
                        loading={fetchingGetWarehouseOrderExtraServices}
                        destroy={destroy}
                        show={showShow}
                        edit={showEdit}
                        filter={filter}
                        setFilter={setFilter}
                        isShow={isFormShow}

                    />
                    </div>
                </div>
            </DefaultCard>

            {showingCreate ? (

            <DefaultModal
                show={showingCreate}
                handleClose={() => setShowingCreate(false)}
                title="Crear Servicio Adicional"
                showFooter={false}
            >
                <WarehouseExtraServiceCreate
                    quoteId={warehouseOrderId}
                    onSaved={() => {
                        reloadTable();
                        setShowingCreate(false);
                    } }
                    onCancel={() => setShowingCreate(false)}
                    onError={() => setShowingCreate(false)}  
                    />
            </DefaultModal>

            ) : null}

            {showingEdit ? (
            <DefaultModal
                show={showingEdit}
                handleClose={hideEdit}
                title="Editar día libre"
                showFooter={false}
            >
                <WarehouseOrderExtraServiceEdit

                extraServiceId={extraServiceIdEdit}
                onSaved={() => {
                    reloadTable();
                    hideEdit();
                }}
                onCancel={hideEdit}
                />
            </DefaultModal>
        ) : null}
         {showingShow ? (
            <DefaultModal
                show={showingShow}
                handleClose={hideShow}
                title="Ver información servicio adicional"
                showFooter={false}

            >  
                <WarehouseOrderExtraServiceShow
                extraServiceId={extraServiceIdShow}
                onCancel={hideShow}
                />
            </DefaultModal>
                    ) : null}
        </>
    );
};

export default WarehouseOrderExtraServiceContainer;
